import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { setupStore, StoreType } from "../redux/store";
import { setupAxiosInterceptors } from "../settings/api";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export default function StoreProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [store, setStore] = useState<StoreType | null>(null);
  useEffect(() => {
    (async () => {
      const createdStore = await setupStore();
      setStore(createdStore);
      // @ts-expect-error
      setupAxiosInterceptors(createdStore);
    })();
  }, []);
  if (!store) return null;
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>{children}</Provider>
    </QueryClientProvider>
  );
}
